module.exports = __webpack_public_path__ + "img/icon-ve_dain.ff82e5d9.svg";